//* ------------------------------------*\
//    $ARIA STRINGS
//* ------------------------------------*/

const ARIA = {
  EXPANDED: 'aria-expanded',
  HIDDEN: 'aria-hidden',
  SELECTED: 'aria-selected'
};

export default ARIA;
